import "./App.css";
import {
  Dashboard,
  AddressBook,
  AddressBookIndividual,
  AddressBookCreate,
  AddressBookEdit,
  Enquiry,
  EnquiryCreate,
  EnquiryEdit,
  EnquiryIndividual,
  Service,
  ServiceIndividual,
  PIFCreate,
  PIFView,
  PIFEdit,
  Login,
  MyProfile,
  Unauthorized,
  NotFound,
  UserAccounts,
  UserAccountCreate,
  InputSettings,
  ServiceTaskCreate,
  ServiceTask,
  ServiceTaskViewSpecific,
  Property,
  PropertyViewSpecific,
  Bloblist,
  Meetings,
  MeetingsCreate,
  MeetingsEdit,
} from "./pages";
import { Layout } from "./components";
import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";

function App() {
  const state = useSelector((state) => state.UserReducer);
  return (
    <Routes>
      <Route path='/' element={<Layout />}>
        {/* <Route path='/' element={<Dashboard />} /> */}
        {/* <Route path='login' element={<Login />} /> */}
        {/* Protected Routes */}
        <Route path='/login' element={state.user ? <Dashboard /> : <Login />} />
        <Route
          path='/'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <Dashboard />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/user/my-profile'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <MyProfile />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/user/manage-user-accounts'
          element={
            state.user ? (
              ["manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <UserAccounts />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/admin/form-input-settings'
          element={
            state.user ? (
              ["manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <InputSettings />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/user/manage-user-accounts/create'
          element={
            state.user ? (
              ["manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <UserAccountCreate />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/meetings'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <Meetings />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/meetings/create'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <MeetingsCreate />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/meetings/edit/:meetingId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <MeetingsEdit />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/addressbook'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <AddressBook />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/addressbook/:addressBookId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <AddressBookIndividual />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/addressbook/create'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <AddressBookCreate />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/addressbook/edit/:addressBookId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <AddressBookEdit />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />

        <Route
          path='/enquiry'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <Enquiry />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />

        <Route
          path='/enquiry/:enquiryId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <EnquiryIndividual />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/enquiry/create'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <EnquiryCreate />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/enquiry/edit/:enquiryId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <EnquiryEdit />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />

        <Route
          path='/serviceticket'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <Service />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/serviceticket/:serviceTicketId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <ServiceIndividual />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/serviceticket/pif/create/:serviceTicketId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <PIFCreate />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/serviceticket/pif/:propertyInformationId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <PIFView />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/serviceticket/pif/edit/:serviceTicketId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <PIFEdit />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/servicetask'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <ServiceTask />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/servicetask/create'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <ServiceTaskCreate />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/servicetask/create/:serviceTicketId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <ServiceTaskCreate />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/servicetask/:serviceTaskId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <ServiceTaskViewSpecific />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/property'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <Property />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/property/:propertyInformationId'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <PIFView />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
        <Route
          path='/bloblist'
          element={
            state.user ? (
              ["user", "lead", "manager", "admin", "super-admin"].includes(
                state.user.aclGroup,
              ) ? (
                <Bloblist />
              ) : (
                <Unauthorized />
              )
            ) : (
              <Login />
            )
          }
        />
      </Route>
      <Route path='*' element={<NotFound />} />
    </Routes>
  );
}

export default App;
